import React from 'react'
import { Delegator } from '@evertel/schema-parser'
import { View } from '@react-pdf/renderer'

interface RowProps {
    value: any
    items: any
}

const Row: React.FC<RowProps> = ({
    value: parentValue,
    items,
    ...otherProps
}) => {

    if (!items?.length) return null

    return (
        <View style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            gap: 15,
            marginBottom: 15
        }}>
            {items.map(({id: itemId, ...itemProps}, i: number) => {
                const itemValue = parentValue?.[itemId]

                return (
                    <Delegator
                        key={i}
                        {...otherProps}
                        {...itemProps}
                        id={itemId}
                        value={itemValue}
                    />
                )
            })}
        </View>
    )
}

export { Row }
Row.displayName = 'Row (PDF)'
